// Conflict-of-interest state for a deal. Informational only: a conflict NEVER blocks a
// stage move, it produces warnings (decision: Graham, 2026-10-10).
//   "potential" – latest check recorded a potential conflict
//   "not_run"   – no check recorded (or legacy deal without an outcome)
//   "ok"        – cleared or managed
export function conflictState(deal) {
    const o = deal && deal.conflict_outcome;
    if (o === "potential_conflict") return "potential";
    if (o === "clear" || o === "conflict_managed") return "ok";
    if (deal && deal.conflict_checked === true) return "ok"; // legacy rows
    return "not_run";
}

export function conflictMoveWarning(deal, newStage, firstStage) {
    const s = conflictState(deal);
    if (s === "potential") return `Potential conflict of interest flagged on ${deal.company_name}. You can continue, but review it.`;
    if (s === "not_run" && newStage !== firstStage) return `No conflict check recorded for ${deal.company_name}.`;
    return null;
}
